var _circle, _rect, _circle2, _circle3, _line, _circle4, _rect2, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 90,
    fill: "#f7f9fc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 55,
    width: 70,
    height: 85,
    rx: 20,
    ry: 20,
    fill: "#e6eef5",
    stroke: "#64748b",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 8,
    fill: "#475569"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 90,
    r: 8,
    fill: "#475569"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 55,
    x2: 100,
    y2: 40,
    stroke: "#64748b",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 35,
    r: 6,
    fill: "#64748b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 110,
    width: 40,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#475569"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 125,
    x2: 125,
    y2: 125,
    stroke: "#64748b",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent);
export default __webpack_public_path__ + "static/media/agent.a207153143812aa50afe29b9931fdc4e.svg";
export { ForwardRef as ReactComponent };